/* eslint-disable no-alert */
/* eslint-disable react-native/no-inline-styles */
import {useNavigation} from '@react-navigation/native';
import {Button, Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {
  Image,
  Linking,
  Platform,
  ScrollView,
  StyleSheet,
  View,
} from 'react-native';
// import {useSelector} from 'react-redux';
import {
  facebookIcon,
  gmailIcon,
  instagramIcon,
  phoneCallIcon,
  starBanner,
} from '../../assets/images';
import {px, useIsLandscape} from '../../utils';
import {Page} from '../components';

const EmailIcon = (props) => (
  <Image
    style={{
      width: props.style.width,
      height: props.style.height,
      marginHorizontal: props.style.marginHorizontal,
    }}
    source={gmailIcon}
    resizeMode="contain"
  />
);
const PhoneIcon = (props) => (
  <Image
    style={{
      width: props.style.width,
      height: props.style.height,
      marginHorizontal: props.style.marginHorizontal,
    }}
    source={phoneCallIcon}
    resizeMode="contain"
  />
);
const FacebookIcon = (props) => (
  <Image
    style={{
      width: props.style.width,
      height: props.style.height,
      marginHorizontal: props.style.marginHorizontal,
    }}
    source={facebookIcon}
    resizeMode="contain"
  />
);
const InstagramIcon = (props) => (
  <Image
    style={{
      width: props.style.width,
      height: props.style.height,
      marginHorizontal: props.style.marginHorizontal,
    }}
    source={instagramIcon}
    resizeMode="contain"
  />
);

const ContactUs = () => {
  const isLandscape = useIsLandscape();
  // const isAuthenticated = useSelector((state) =>
  //   Boolean(state.auth.accessToken),
  // );

  const handlePress = async (url) => {
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
    } else {
      alert(`Don't know how to open this URL: ${url}`);
    }
  };

  const navigation = useNavigation();
  const canGoBack = navigation.canGoBack();

  return (
    <Page
      header={{
        title: 'Contact Us',
        showDrawerAction: !canGoBack,
        showBackAction: canGoBack ? true : false,
      }}
      scrollViewStyle={{flex: 1}}>
      <View
        style={[{flex: 1}, isLandscape ? {flexDirection: 'row'} : undefined]}>
        {isLandscape && (
          <View style={{flex: 1, justifyContent: 'center', maxWidth: 600}}>
            <Image
              source={starBanner}
              resizeMode="contain"
              style={styles.starImage}
            />
          </View>
        )}
        <View
          style={{
            flex: 1,
            justifyContent: 'space-between',
            alignSelf: 'center',
            maxWidth: 400,
          }}>
          <ScrollView contentContainerStyle={{flex: 1, paddingBottom: 10}}>
            <View style={styles.topWrapper}>
              <Text style={styles.titleText}>{'Star Tutor HQ'}</Text>
              <Text style={styles.addressText}>
                {
                  '21-1, Jalan Opera E U2/E, Taman TTDI\nJaya, 40150 Shah Alam, Selangor'
                }
              </Text>
            </View>
            <Layout style={styles.bottomWrapper}>
              <Button
                style={styles.button}
                appearance="ghost"
                status="basic"
                accessoryLeft={PhoneIcon}
                onPress={() => handlePress('tel:+60199559941')}>
                <Text style={styles.btnText}>{'+6019 955 9941'}</Text>
              </Button>
              <Button
                style={styles.button}
                appearance="ghost"
                status="basic"
                accessoryLeft={PhoneIcon}
                onPress={() => handlePress('tel:+60148489941')}>
                <Text style={styles.btnText}>{'+6014 848 9941'}</Text>
              </Button>
              <Button
                style={styles.button}
                appearance="ghost"
                status="basic"
                accessoryLeft={EmailIcon}
                onPress={() =>
                  handlePress('mailto:startutortuition@gmail.com')
                }>
                <Text style={styles.btnText}>
                  {'startutortuition@gmail.com'}
                </Text>
              </Button>
              <Button
                style={styles.button}
                appearance="ghost"
                status="basic"
                accessoryLeft={FacebookIcon}
                onPress={() =>
                  handlePress('https://www.facebook.com/startutor.my')
                }>
                <Text style={styles.btnText}>{'startutor.my'}</Text>
              </Button>
              <Button
                style={styles.button}
                appearance="ghost"
                status="basic"
                accessoryLeft={InstagramIcon}
                onPress={() =>
                  handlePress('https://instagram.com/_u/startutor.my')
                }>
                <Text style={styles.btnText}>{'startutor.my'}</Text>
              </Button>

              {Platform.OS !== 'ios' && (
                <Button
                  style={styles.btnLinkTree}
                  status="primary"
                  size="large"
                  onPress={() =>
                    handlePress(
                      'http://wa.me/60199559941?text=[Contact%20from%20Application]',
                    )
                  }>
                  {'WhatsApp Us'}
                </Button>
              )}
            </Layout>
          </ScrollView>
        </View>
      </View>
    </Page>
  );
};

const styles = StyleSheet.create({
  button: {
    justifyContent: 'flex-start',
    color: '#000',
  },
  btnText: {
    color: '#000',
    fontSize: 14,
    fontWeight: '500',
    opacity: 0.87,
  },
  topWrapper: {
    paddingHorizontal: px(24),
    marginBottom: px(12),
    marginTop: px(31),
  },
  bottomWrapper: {
    marginTop: px(1),
  },
  addressText: {
    marginTop: px(17),
    fontSize: 15,
    fontWeight: '400',
  },
  titleText: {
    fontSize: 20,
    fontWeight: '500',
  },
  btnLinkTree: {
    marginHorizontal: px(16),
    marginTop: 10,
    marginBottom: px(40),
    maxWidth: 330,
  },
  starImage: {
    alignSelf: 'center',
    width: px(250),
    height: px(250),
    marginRight: 26,
    marginLeft: 64,
  },
});

export default ContactUs;
